"use client";

import Image from "next/image";
import { Play } from "lucide-react";

import { Paragraph } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name.json";
import EVENT_ATTRIBUTE from "@/hooks/use-moengage/event-attribute.json";

function TopperCard({
  id,
  name,
  title,
  type,
  s3Url,
  achievement,
  profileImg,
  onVideoSelect,
}) {
  const trackMoengageEvent = useMoengageEventTracker();

  const handleOnVideoSelect = () => {
    if (typeof onVideoSelect !== "function") return;

    onVideoSelect(s3Url);

    trackMoengageEvent(EVENT_NAME.TESTIMONIAL_VIDEO_PLAY, {
      [EVENT_ATTRIBUTE.TESTIMONIAL_ID]: id,
      [EVENT_ATTRIBUTE.TESTIMONIAL_NAME]: name,
      [EVENT_ATTRIBUTE.TESTIMONIAL_VIDEO_ID]: s3Url,
      [EVENT_ATTRIBUTE.TESTIMONIAL_TYPE]: type,
    });
  };

  return (
    <div
      className="flex flex-col p-3 gap-y-2 border border-grayscale-input rounded-lg"
      onClick={handleOnVideoSelect}
    >
      <div className="relative flex aspect-287/160 overflow-hidden rounded">
        <Image src={profileImg} alt="Topper" sizes="300px" fill />

        <div className="flex items-center justify-between self-end w-full bg-grayscale-body/80 backdrop-blur-lg py-1.75 px-3 z-10">
          <Paragraph
            variant="b3"
            weight="sb"
            className="line-clamp-2 text-primary-foreground"
          >
            {name || "No Name"}
          </Paragraph>

          <Button
            variant="icon"
            className="p-0 bg-primary-foreground size-6 rounded-full"
          >
            <Play className="size-2.5 fill-grayscale-header-weak text-grayscale-header-weak" />
          </Button>
        </div>
      </div>

      <Paragraph
        variant="b4"
        weight="sb"
        className="text-grayscale-header-weak line-clamp-1"
      >
        {achievement || "No Achievement"}
      </Paragraph>
      <Paragraph
        variant="b5"
        className="text-grayscale-label line-clamp-2 h-10"
      >
        {title || "No Title"}
      </Paragraph>
    </div>
  );
}

export default TopperCard;
